import Constants from 'expo-constants';
import { Platform } from 'react-native';
import logger from '../utils/logger';

// ⚙️ إعدادات السيرفر - Reading from app.json extra config
// Uses Constants.expoConfig.extra.apiBaseUrl (set in app.json)

// قراءة الإعدادات من app.json
const API_URL_FROM_CONFIG = Constants.expoConfig?.extra?.apiBaseUrl || '';
const FALLBACK_URL_FROM_CONFIG = Constants.expoConfig?.extra?.fallbackApiUrl || '';

// للإنتاج (Production) - يُقرأ من app.json
export const PROD_API_URL = API_URL_FROM_CONFIG || 'https://api.iot-edge.io/api/v1';
export const FALLBACK_API_URL = FALLBACK_URL_FROM_CONFIG || 'https://api.iot-edge.io/api/v1';

// للتطوير المحلي (Development)
// Port 3001 is bound to 127.0.0.1 only (not accessible from phones/external devices).
// All platforms must use the HTTPS production URL which goes through Nginx.
const DEV_API_URL = 'https://api.iot-edge.io/api/v1';

// 🔧 CRITICAL FIX: APK builds always use HTTPS production URL
// Only use DEV_API_URL in Expo Go development (__DEV__ === true)

// For APK builds (standalone app), ALWAYS use production HTTPS
const isStandaloneAPK =
  (Constants.appOwnership != null && String(Constants.appOwnership) === 'standalone') || !__DEV__;

// For web, check if loaded over HTTPS
const isSecurePage =
  Platform.OS === 'web' && typeof window !== 'undefined' && window.location.protocol === 'https:';

// Check if running on production domain
const isProductionDomain =
  Platform.OS === 'web' &&
  typeof window !== 'undefined' &&
  (window.location.hostname === 'app.iot-edge.io' ||
    window.location.hostname === 'iot-edge.io' ||
    window.location.hostname === 'mobile.iot-edge.io');

// 🎯 USE PRODUCTION URL IF:
// 1. Standalone APK (not Expo Go)
// 2. Web page loaded over HTTPS
// 3. Web on production domain
export const API_BASE_URL =
  isStandaloneAPK || isSecurePage || isProductionDomain
    ? PROD_API_URL // يُقرأ من app.json في الإنتاج
    : DEV_API_URL; // IP محلي في التطوير

// Debug logging to verify correct API URL is used
logger.log('🌐 API Configuration:', {
  platform: Platform.OS,
  __DEV__,
  appOwnership: Constants.appOwnership,
  isStandaloneAPK: isStandaloneAPK,
  selectedUrl: API_BASE_URL,
});

if (Platform.OS === 'web' && typeof window !== 'undefined') {
  logger.log('🔧 Web-specific config:', {
    hostname: window.location.hostname,
    protocol: window.location.protocol,
    isSecurePage: window.location.protocol === 'https:',
    isProductionDomain: ['app.iot-edge.io', 'iot-edge.io', 'mobile.iot-edge.io'].includes(
      window.location.hostname,
    ),
  });
}

// ملاحظات:
// - Global production API: https://api.iot-edge.io
// - Saudi node (Node B): set app.json extra.apiBaseUrl to https://api.iot-edge.sa/api/v1
//   and EAS env EXPO_PUBLIC_WS_URL=wss://api.iot-edge.sa — do not change global .io traffic
// - Always using HTTPS with domain for security
// - SSL certificates managed by Let's Encrypt
// - Production-ready configuration

export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  REFRESH: '/auth/refresh',
  ME: '/auth/me',

  // Devices
  DEVICES: '/devices',
  DEVICE_DETAIL: (deviceId: string) => `/devices/${deviceId}/detail`,

  // Telemetry
  TELEMETRY_LATEST: (deviceId: string) => `/devices/${deviceId}/telemetry/latest`,
  TELEMETRY_HISTORY: (deviceId: string) => `/devices/${deviceId}/telemetry`,
  TELEMETRY_STATISTICS: (deviceId: string) => `/devices/${deviceId}/telemetry/statistics`,

  // Alarms
  ALARMS: '/alarms',
  ALARM_ACK: (alarmId: string) => `/alarms/${alarmId}/acknowledge`,

  // Notifications
  NOTIFICATIONS: '/notifications',
  NOTIFICATION_READ: (notificationId: string) => `/notifications/${notificationId}/read`,

  // Push Token
  REGISTER_PUSH_TOKEN: '/users/me/push-token',
};
